import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
}
export const PinterestIcon: FC<IconProps> = ({ className, size }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 40 40'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M35.5 20C35.5 28.5625 28.5625 35.5 20 35.5C18.375 35.5 16.8125 35.3125 15.375 34.8125C16 33.8125 16.9375 32.125 17.3125 30.75C17.5 30.0625 18.25 27.0625 18.25 27.0625C18.75 28.0625 20.25 28.875 21.8125 28.875C26.5 28.875 29.875 24.5625 29.875 19.25C29.875 14.125 25.6875 10.25 20.3125 10.25C13.625 10.25 10.0625 14.75 10.0625 19.625C10.0625 21.9375 11.25 24.75 13.1875 25.6875C13.5 25.8125 13.6875 25.75 13.75 25.4375C13.75 25.25 14.0625 24.1875 14.1875 23.6875C14.1875 23.5625 14.1875 23.375 14.0625 23.25C13.4375 22.5 12.9375 21.0625 12.9375 19.6875C12.9375 16.3125 15.5 13 19.9375 13C23.6875 13 26.375 15.5625 26.375 19.3125C26.375 23.5 24.25 26.375 21.5 26.375C20 26.375 18.875 25.125 19.1875 23.625C19.625 21.75 20.5 19.75 20.5 18.4375C20.5 17.25 19.875 16.25 18.5625 16.25C17 16.25 15.75 17.875 15.75 20C15.75 21.375 16.1875 22.3125 16.1875 22.3125C16.1875 22.3125 14.6875 28.8125 14.375 30C14.0625 31.375 14.1875 33.25 14.3125 34.4375C8.5625 32.1875 4.5 26.625 4.5 20C4.5 11.4375 11.4375 4.5 20 4.5C28.5625 4.5 35.5 11.4375 35.5 20Z'
        }
        fill={'#141414'}
      />
    </svg>
  )
}
